import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class ETTService extends CRUDService{
    constructor() {
        super("ett");
    }

    listByPrefixoNomeFantasia(nomeFantasia) {
        return http.get(`/ett/prefixo/${nomeFantasia}`);
    }

    listByNomeCompetenciaCargo(idCompetenciaCargo, empresaGloboId) {
        return http.get(`/ett/competencia/${encodeURIComponent(idCompetenciaCargo)}/${empresaGloboId}`);
    }
}
